import "./GeneralInfoForm.scss";
import InfoContext from "pages/InfoContext";
import {
  CONSULTANT_FORM_LABELS,
  CONSULTANT_GENERAL_INFO_DEFAULT_VALUES,
} from "constants/forms";
import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";
import {
  renderDisplayReadOnlyField,
  renderInputMobility,
  renderInputSkills,
} from "components/form/CommonInputs";
import InputText from "core/inputs/input-text/InputText";
import { useContext, useEffect } from "react";
import { phoneSize } from "utils/screenSizes";
import { getFormattedDate } from "utils/functions";
import { buildDybProfileUrl } from "utils/helper";
import PropTypes from "prop-types";
import { SCHOOL_NOT_SET } from "constants/constants";

const GeneralInfoForm = ({ control, register, setValue, watch }) => {
  const { consultantBySlug, lang, isDisabledCell, currencyList } =
    useContext(InfoContext);
  const {
    dyb_skills,
    dyb_geo,
    first_name,
    last_name,
    start_date,
    degree,
    school,
    dyb_showcase_id,
  } = consultantBySlug || {};

  const skills = dyb_skills?.map((skill) => {
    return { label: skill, value: "" };
  });

  const mobilities = dyb_geo?.map((geo) => {
    return { label: geo, value: "" };
  });

  const mobilityInput = () => (
    <div className={`cell-padding ${isDisabledCell}`}>
      {renderInputMobility({ control, register, mobilities })}
    </div>
  );

  useEffect(() => {
    if (consultantBySlug) {
      const defaultKeys = Object.keys(CONSULTANT_GENERAL_INFO_DEFAULT_VALUES);
      Object.keys(consultantBySlug).forEach((elm) => {
        if (elm === "first_name" || elm === "last_name") {
          setValue("dyb_name", `${first_name} ${last_name}`);
        } else if (defaultKeys.includes(elm) && consultantBySlug[elm]) {
          setValue(elm, consultantBySlug[elm]);
        }
      });
      setValue("start_date", getFormattedDate(start_date, lang));
      setValue(
        "degree_and_school",
        [degree, school].filter((e) => e && e !== SCHOOL_NOT_SET).join(", ")
      );
    }
  }, [consultantBySlug, lang]);

  const renderLine1 = () => (
    <div className="line-1">
      <div className={`cell-padding ${isDisabledCell}`}>
        {renderDisplayReadOnlyField({
          control,
          label: { id: "dyb_name_label", defaultMessage: "Recherche DYB" },
          register,
          name: "dyb_name",
          isUnderline: true,
          onClick: () => {
            window.open(
              buildDybProfileUrl(dyb_showcase_id),
              "_blank",
              "noopener,noreferrer"
            );
          },
        })}
      </div>
      <div className={`cell-padding ${isDisabledCell}`}>
        {renderDisplayReadOnlyField({
          control,
          label: { id: "entry_date_label", defaultMessage: "Date d'entrée" },
          register,
          name: "start_date",
        })}
      </div>
      <div
        className={`cell-padding ${isDisabledCell}`}
        title={`${watch("degree_and_school")}`}
      >
        {renderDisplayReadOnlyField({
          control,
          label: { id: "degree_label", defaultMessage: "Diplômé.e" },
          register,
          name: "degree_and_school",
        })}
      </div>
      <div className={`cell-padding ${isDisabledCell}`}>
        {renderDisplayReadOnlyField({
          control,
          label: { id: "degree_year_label", defaultMessage: "Date du diplome" },
          register,
          name: "degree_year",
        })}
      </div>
      <div className={`cell-padding ${isDisabledCell}`}>
        {renderDisplayReadOnlyField({
          control,
          label: {
            id: "years_experience_label",
            defaultMessage: "Expérience professionnelle",
          },
          register,
          name: "years_experience",
        })}
      </div>
      {phoneSize && mobilityInput()}
    </div>
  );

  const renderLine2 = () => (
    <div className="line-2">
      {!phoneSize && mobilityInput()}
      <div className={`cell-padding ${isDisabledCell}`}>
        {renderInputSkills({ control, register, skills })}
      </div>
      <div className={`cell-padding ${isDisabledCell}`}>
        <InputText
          readOnly={true}
          label={CONSULTANT_FORM_LABELS.salary}
          value={`${consultantBySlug?.salary?.value} ${currencyList?.find((elm) => elm.id === consultantBySlug?.salary?.currency_id)?.currency_symbol || "€"} `}
        />
      </div>
    </div>
  );

  return (
    <div className="general-info-section">
      <div className="general-info-title">
        <Typography
          className="title-3 violet text-uppercase"
          type="h2"
          label={
            <FormattedMessage
              id="general_infos"
              defaultMessage="Info Générales"
            />
          }
        />
      </div>
      <div className="general-info-form ">
        {renderLine1()}
        {renderLine2()}
      </div>
    </div>
  );
};

export default GeneralInfoForm;

GeneralInfoForm.propTypes = {
  control: PropTypes.object,
  setValue: PropTypes.func,
  register: PropTypes.func,
  watch: PropTypes.func,
};
